import(/* webpackMode: "eager" */ "/working_dir/node_modules/next/dist/client/image-component.js");
